/**
 * English (en) translation dictionary — the source of truth for the message
 * shape. `pt.ts` is typed as `Messages` (= typeof this object), so it must
 * mirror these keys exactly or the build fails.
 */
export const en = {
  nav: {
    virtual: 'Virtual Photo',
    museum: 'The Museum',
    visit: 'Visit',
    store: 'Store',
    menu: 'Menu',
  },
  hero: {
    sub: 'Madeira · Portugal',
    titleThin: 'CR7',
    titleShine: 'Museum',
    tagline: 'The legacy of Cristiano Ronaldo, told in his hometown.',
    plan: 'Plan your visit',
    store: 'Online store',
    scroll: 'Scroll',
  },
  stats: {
    ballon: "Ballon d'Or",
    ucl: 'Champions Leagues',
    boots: 'Golden Boots',
    uefa: 'UEFA Best Player',
  },
  virtual: {
    badge: 'Virtual Photo',
    kicker: 'Virtual Photo',
    title: 'CR7 in Augmented Reality',
    text: 'Interact with Cristiano Ronaldo and take photos as if he were right beside you. A new way to live the CR7 experience.',
    cta: 'Learn more',
  },
  museum: {
    kicker: 'The Museum',
    title: 'A life in trophies',
    intro:
      'Every youth and professional trophy won by Cristiano Ronaldo, from his first steps in Madeira to the biggest stages in world football.',
    cards: {
      boots: {
        title: 'Golden Boots',
        text: "Four times Europe's top scorer. The golden boots are here, for posterity.",
      },
      ballon: {
        title: "Ballon d'Or",
        text: 'Five times World Player of the Year, and the greatest Portuguese player of all time.',
      },
      clubs: {
        title: 'Club Trophies',
        text: 'Every trophy won at the clubs he played for, including five UEFA Champions Leagues.',
      },
      fans: {
        title: 'Fan Mail',
        text: 'Fans from all over the world write, draw, paint and send tributes to Cristiano Ronaldo.',
      },
      ar: {
        title: 'Augmented Reality',
        text: 'Interact with Ronaldo and take home a photo beside the star.',
      },
      memorabilia: {
        title: 'Memorabilia',
        text: 'Jerseys, boots, photographs and unique objects that marked the career of the Madeiran star.',
      },
    },
  },
  experience: {
    kicker: 'CR7 Museum Madeira',
    title: 'Where the journey began',
    text: 'Iconic location · Immersive space · A lifetime of trophies',
  },
  visit: {
    kicker: 'Visit',
    title: 'Plan your visit',
    addressLabel: 'Address',
    hoursLabel: 'Opening hours',
    hours: 'Every day · 10:00 – 17:00',
    note: 'In case of occasional closures, information will be shared on social media in advance.',
    contactLabel: 'Contact',
    map: 'View on map',
  },
  footer: {
    tagline: 'The official museum dedicated to Cristiano Ronaldo, in Funchal, Madeira.',
    explore: 'Explore',
    contact: 'Contact',
    location: 'Funchal, Madeira',
    rights: 'All rights reserved.',
  },
};
